import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SignUpFormComponent } from './sign-up-form/sign-up-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { SecondaryLogoComponent } from '../../components/shared/secondary-logo/secondary-logo.component';

@Component({
  selector: 'app-sign-up-page',
  standalone: true,
  imports: [SignUpFormComponent, TranslateModule, SecondaryLogoComponent],
  templateUrl: './sign-up-page.component.html',
  styleUrl: './sign-up-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignUpPageComponent {}
